import { NEXTJS_RSC_TOP_OF_PAGE_CONTENT_250227 } from "@faire/web-api--source/indigofair/settings/NEXTJS_RSC_TOP_OF_PAGE_CONTENT_250227";

import { useAssignSetting } from "./__internal__/useSetting";

export const useAssignSettingRSCTopOfPageContent = () => {
  return useAssignSetting(NEXTJS_RSC_TOP_OF_PAGE_CONTENT_250227);
};
